module.exports = __webpack_public_path__ + "img/9.d4336b54.png";